import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryCity } from '../types/delivery-city.type';
import { ADMIN_DELIVERY_CITIES_API_PATHS } from '../constants/delivery-cities-api-paths.constants';

type UseArchiveDeliveryCityResult = {
  archiveDeliveryCity: (deliveryCityId: string) => Promise<DeliveryCity | null>;
  isSubmitting: boolean;
};

export function useArchiveDeliveryCity(): UseArchiveDeliveryCityResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const archiveDeliveryCity = async (deliveryCityId: string): Promise<DeliveryCity | null> => {
    setIsSubmitting(true);

    try {
      const archivedDeliveryCity = await HttpClient.delete<DeliveryCity>(
        ADMIN_DELIVERY_CITIES_API_PATHS.ARCHIVE_DELIVERY_CITY(deliveryCityId)
      );

      enqueueSnackbar('Ville de livraison archivée', { variant: 'success' });
      return archivedDeliveryCity;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, "Une erreur est survenue lors de l'archivage de la ville de livraison"),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { archiveDeliveryCity, isSubmitting };
}
